<template>
  <div>
    <el-form
      ref="searchForm"
      :inline="true"
      class="searchBoxLine"
      :model="searchForm"
    >
      <el-form-item label="项目名称:" prop="projectName" clearable>
        <el-input
          v-model.trim="searchForm.projectName"
          placeholder="填写项目名称"
        />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model="searchForm.contractNum" placeholder="填写合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="orderUnit">
        <el-input v-model="searchForm.orderUnit" placeholder="填写代理商名称" />
      </el-form-item>
      <el-form-item label="部门:" prop="departmentName">
        <el-input v-model="searchForm.departmentName" placeholder="填写部门" />
      </el-form-item>
      <el-form-item label="区域:" prop="regionName">
        <el-input
          v-model="searchForm.regionName"
          style="width: 80px"
          placeholder="填写区域"
        />
      </el-form-item>
      <el-form-item label="销售:" prop="salesManName">
        <el-input
          v-model="searchForm.salesManName"
          placeholder="填写销售名称"
        />
      </el-form-item>
      <el-form-item label="客户合同编号:" prop="customerContractNum">
        <el-input
          v-model="searchForm.customerContractNum"
          placeholder="填写客户合同编号"
        />
      </el-form-item>

      <!-- D28：新增「订单分类」查询条件，对标合同处理页的订单分类筛选 -->
      <el-form-item label="订单分类:" prop="contractType">
        <el-select
          v-model="searchForm.contractType"
          style="width: 140px"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in orderType"
            :key="option.code"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="合同状态:" prop="contractStatus">
        <el-select
          v-model="searchForm.contractStatus"
          style="width: 130px"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in contractStatus"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="现销/赊销:" prop="saleModesName">
        <el-select
          v-model="searchForm.saleModesName"
          style="width: 90px"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in salesTypeList"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="是否已下单:" prop="postStatus">
        <el-select
          v-model="searchForm.postStatus"
          style="width: 80px"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in postStatus"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="合同时间:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchTime.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchTime.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="抛单时间:" prop="postBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchTime.postBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchTime.postEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="最终客户:" prop="finalCustomer">
        <el-input
          v-model.trim="searchForm.finalCustomer"
          placeholder="填写最终客户"
        />
      </el-form-item>
      <el-form-item label="产品型号:" prop="productName">
        <el-input
          v-model.trim="searchForm.productName"
          placeholder="填写产品型号"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>

      <div class="operate-btn-wrap">
        <el-button v-if="!$store.state.user.asSale" type="primary" :loading="submitLoading" @click="exportData">
          导出云桌面产品合同
        </el-button>
      </div>

      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column
            prop="projectName"
            label="项目名称"
            align="left"
            min-width="260"
            fixed="left"
          >
            <template v-slot="{ row }">
              <el-button
                type="text"
                class="el-btn-text-left"
                @click="jumpProjectDeatil(row)"
              >
                {{ row.projectName }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="contractNum"
            label="合同编号"
            align="left"
            min-width="130"
            fixed="left"
          />
          <el-table-column
            prop="erpOrderNum"
            label="ERP订单号"
            align="left"
            width="100"
          />
          <el-table-column
            prop="orderUnit"
            label="代理商名称"
            align="left"
            width="200"
          />
          <el-table-column
            prop="departmentName"
            label="部门"
            align="left"
            width="290"
          />
          <el-table-column
            prop="regionName"
            label="区域"
            align="left"
            width="60"
          />
          <el-table-column
            prop="contractType"
            label="订单分类"
            align="left"
            width="110"
          />

          <el-table-column
            prop="isOrderAutoPassing"
            label="是否自动化"
            align="left"
            width="90"
          >
            <template v-slot="{row}">
              <span>{{ row.isOrderAutoPassing ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="isOrderAutoPassingSuccess"
            label="自动过单状态"
            align="left"
            width="100"
          >
            <template v-slot="{row}">
              <span v-if="!row.isOrderAutoPassingSuccess || row.isOrderAutoPassingSuccess === 0">
                <el-button v-if="row.aid" type="text" @click="passingStatus(row.aid,'未过单原因')">未过单</el-button>
                <span v-if="!row.aid">未过单</span>
              </span>
              <span v-if="row.isOrderAutoPassingSuccess === 1 ">成功</span>
              <span v-if="row.isOrderAutoPassingSuccess === 2 ">
                <el-button v-if="row.aid" type="text" @click="passingStatus(row.aid,'失败原因')">失败</el-button>
                <span v-if="!row.aid">失败</span>
              </span>
            </template>
          </el-table-column>

          <el-table-column
            prop="salesManName"
            label="销售"
            align="left"
            width="80"
          />
          <el-table-column
            prop="createTime"
            label="合同时间"
            align="left"
            width="160"
          />
          <el-table-column
            prop="contractStatusOp"
            label="合同状态"
            align="left"
            width="200"
          />
          <el-table-column
            prop="saleModesName"
            label="现销/赊销"
            align="left"
            width="80"
          />
          <el-table-column
            prop="assignRatio"
            label="分配比例(%)"
            align="right"
            width="100"
            header-align="left"
          />
          <el-table-column
            prop="assignTime"
            label="付款时间"
            align="left"
            width="140"
          />
          <el-table-column
            prop="postTime"
            label="抛单时间"
            align="left"
            width="150"
          />
          <el-table-column
            prop="createTime"
            label="合同附件"
            align="left"
            width="100"
          >
            <template v-slot="{ row }">
              <el-button
                v-if="row.statusValue !== '待提交'"
                slot="reference"
                type="text"
                @click="showAttachment(row.contractId)"
              >
                合同附件
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="signStatus"
            label="代理商已签章"
            align="left"
            width="100"
          >
            <template v-slot="{ row }">
              <span v-if="row.signStatus === '0' || row.signStatus === null">否</span>
              <span v-if="row.signStatus === '1' || row.signStatus === '3'">是</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="signStatus"
            label="锐捷已签章"
            align="left"
            width="90"
          >
            <template v-slot="{ row }">
              <span v-if="row.signStatus === '3'">是</span>
              <span v-if="row.signStatus !== '3'">否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="contractNum"
            label="操作"
            align="left"
            min-width="200"
            fixed="right"
          >
            <template v-slot="{ row }">
              <span v-if="!$store.state.user.asSale">
                <el-button type="text" @click="showFile(row)">签章</el-button>
                <el-button
                  v-if="
                    row.contractType !== '国际业务下单' &&
                      (row.contractType !== '国际分销下单') &
                      (row.contractType !== '服务订单') &&
                      row.contractStatus === 2
                  "
                  type="text"
                  @click="createNewExtraPriceContract(row,1)"
                >
                  生成价外费用
                </el-button>
              </span>

              <!-- 021：服务订单（服务独立销售）必须可发起九类既有退换货原因，不再排除；
                   历史 2023 年「运维-服务下单不支持退换货」限制已被专项需求 1.5 取代。
                   017：销售借用单按 PRD 2.7 复用「申请退换货」入口，弹窗内新增
                   “销售借用纯服务退货”；该新流程仅商务可发起（销售视角弹窗不含该项）。
                   销售借用单的入口本身恢复历史能力，销售与商务均可见（2026-10-12 用户决策） -->
              <el-button v-if="showApplyReturnButton(row)" type="text" @click="applyChange(row)">
                申请退换货
              </el-button>
              <span v-if="!$store.state.user.asSale">
                <el-button v-if="row.operate ===2" type="text" @click="createNewExtraPriceContract(row,2)">
                  编辑
                </el-button>
                <el-button v-if="row.operate ===1" type="text" @click="recall(row)">
                  召回
                </el-button>
                <el-button v-if="row.operate === 2" type="text" @click="discard(row)">
                  废弃
                </el-button>
                <el-button type="text" @click="openTicketAgain(row)">
                  提前开票
                </el-button>
                <el-button v-if="String(row.erpOrderNum || '').trim()" type="text" @click="openSalesmanChange(row)">
                  销售人员变更
                </el-button>
                <el-button v-if="row.distributeFlag" type="text" @click="$router.push({name:'distributionSw',params:{contractNum:row.contractNum}})">
                  分配
                </el-button>
                <el-button v-if="row.distributeContractTypeFlag" type="text" @click="openDeliverGoods(row)">
                  申请发货
                </el-button>
                <el-button v-if="showEsing(row)" type="text" @click="downStarting(row)">
                  下载服务启动函
                </el-button>
                <el-button v-if="showEsing(row)" type="text" @click="signature(row)">
                  签章服务启动函
                </el-button>
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="date" label="合同附件" width="70" align="left">
            <template v-slot="{row}">

            </template>
          </el-table-column> -->
        </el-table>
        <div style="text-align: right; margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </el-form>
    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-num="contractNum" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="销售人员变更" :visible.sync="salesmanChangeVisible" width="520px" @closed="resetSalesmanChange">
      <el-form label-width="110px">
        <el-form-item label="原人员:">
          <span>{{ salesmanChangeRow.salesManName }}</span>
        </el-form-item>
        <el-form-item label="变更后人员:" required>
          <el-select
            v-model="selectedSalesman"
            value-key="userID"
            filterable
            remote
            reserve-keyword
            placeholder="请输入变更后人员"
            :remote-method="searchSalesman"
            :loading="salesmanSearchLoading"
            style="width: 100%;"
          >
            <el-option
              v-for="item in salesmanOptions"
              :key="item.userID"
              :label="item.userName"
              :value="item"
            >
              <span>{{ item.userName }}</span>
              <span class="salesman-option-dept">{{ item.deptName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变更后部门:">
          <span>{{ selectedSalesman.deptName || '-' }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="salesmanChangeVisible = false">取消</el-button>
        <el-button type="primary" :loading="salesmanChangeLoading" @click="submitSalesmanChange">确定</el-button>
      </span>
    </el-dialog>
    <contract-file-dialog ref="fileDialog" />
    <el-dialog title="选择退换货原因" :visible.sync="changeReasonVisible" width="400px">
      <template v-if="!$store.state.user.asSale">
        <div class="cause-list-style">
          <el-radio-group v-model="radio">
            <el-radio label="1">齐套不提货撤单</el-radio>
            <el-radio label="2">产品功能问题</el-radio>
            <el-radio label="3">产品缺货或停产</el-radio>
            <!-- 2026 退换货优化专项：申请退换货时不再提供「其他特殊原因」（orderType=4）；
                 原类型已拆分为税率变更、订单金额差错调整、订单基础属性变更、发票信息变更。
                 历史单据仍保留该原因，故查询筛选（退换货类型）不做改动 -->
            <el-radio label="7">税率变更</el-radio>
            <el-radio label="6">订单录入&发运差错</el-radio>
            <el-radio label="8">订单金额差错调整</el-radio>
            <!-- 016：本项由 release 线 `8d7599f5`（2026-08-26）加入并已在 UAT；
                 开发分支此前缺失，此处补齐以免本次改动把它回退掉 -->
            <el-radio label="9">订单基础属性变更</el-radio>
            <!-- 017：按 PRD 2.7 在弹窗上“增加”销售借用纯服务退货，
                 仅订单分类=销售借用下单且仅商务可见；该流程在 CES 本地办理，不进入 ECP -->
            <el-radio v-if="isSalesBorrowContract" label="10">销售借用纯服务退货</el-radio>
          </el-radio-group>
        </div>
      </template>
      <template v-else>
        <el-radio v-model="radio" label="5">
          市场销售原因
        </el-radio>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="changeReasonVisible = false">关闭</el-button>
        <el-button type="primary" @click="submitChange()">提交</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="exportUrl" target="_blank" />
    <do-esign ref="doEsign" @CompleteEsign="CompleteEsign" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { downloadUrlFile } from '@/libs/util.js';
import {
  selectContractForAssistant,
  createNewExtraPriceContract,
  exportFinancialSpecialProductInfo,
  selectById,
  deleteNewExtraPriceContract,
  recallNewExtraPriceContract,
  getContractNumByOldNum,
  printInitiationLetterPdf,
  initiationLetterElectronicSignature,
  getUserByName,
  changeContractSalesman
} from '@/API';
import contractFileDialog from '../orderPersion/contract/contractFileDialog';
import contractAttachment from './contractAttachment';
import doEsign from '@/components/doEsign';
export default {
  components: {
    contractFileDialog,
    contractAttachment,
    doEsign
  },

  data () {
    return {
      searchTime: {
        createBeginTime: '2021-01-01',
        createEndTime: '',
        postBeginTime: '',
        postEndTime: ''
      },
      submitLoading: false,
      searchForm: {
        projectName: '',
        contractNum: '',
        orderUnit: '',
        departmentName: '',
        regionName: '',
        saleModesName: '',
        finalCustomer: '',
        productName: '',
        // outer
        contractStatus: '',
        postStatus: '',
        customerContractNum: '',
        salesManName: '',
        // D28：订单分类（对应后端 contract_type 精确匹配）
        contractType: ''
      },
      contractNum: '',
      radio: '',
      contractVisible: false,
      changeReasonVisible: false,
      changeReasonRow: {},
      tableLoading: false,
      tableData: [
      ],
      Loading: false,
      exportUrl: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchTime.createBeginTime) {
            let date = new Date(this.searchTime.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      isDown: false, // 下载防抖
      isSignature: false, // 签章防抖
      salesmanChangeVisible: false,
      salesmanChangeLoading: false,
      salesmanSearchLoading: false,
      salesmanChangeRow: {},
      selectedSalesman: {},
      salesmanOptions: [],
      salesmanSearchTimer: null
    };
  },
  mounted () {
    this.radio = this.$store.state.user.asSale ? '5' : '1';
    // D28：初始化订单分类下拉枚举（store 内部有幂等判空，重复调用不会重复请求）
    this.initOrderType();
    this.doSearch();
  },

  computed: {
    ...mapState({
      salesTypeList: state => state.enumeration.salesTypeList, //  现销/赊销
      contractStatus: state => state.enumeration.contractStatus,
      postStatus: state => state.enumeration.postStatus,
      orderType: state => state.enumeration.orderType // 订单分类
    }),
    // 当前弹窗对应合同是否为销售借用单（017 专用入口判定）
    isSalesBorrowContract () {
      return this.changeReasonRow && this.changeReasonRow.contractType === '销售借用下单';
    }
  },

  methods: {
    ...mapActions('enumeration', [
      'initOrderType'
    ]),
    // 申请退换货按钮显隐（2026-10-12 用户当前决策）：
    // 销售借用单（订单分类=销售借用下单 + 订单员已发布）恢复历史能力，销售与商务均显示入口；
    // 新流程「销售借用纯服务退货」（弹窗 label=10）仍仅商务可发起——该选项位于弹窗
    // 非销售视角分支，销售视角进入后仅可选「市场销售原因」，仍走 ECP 既有链路；
    // 其他订单分类沿用原有排除规则和 applyReturn 开关
    showApplyReturnButton (row) {
      if (row.contractStatus !== 2) return false;
      if (row.contractType === '销售借用下单') return true;
      return !['国际业务下单', '国际分销下单'].includes(row.contractType) && row.applyReturn;
    },
    // 017：跳转 CES 本地销售借用纯服务退货申请页（不经过 ECP）
    applySalesBorrowServiceReturn (row) {
      this.changeReasonVisible = false;
      this.$router.push({
        name: 'salesBorrowPureServiceReturn',
        params: { contractId: row.contractId }
      });
    },
    // 跳转项目详情
    jumpProjectDeatil (row) {
      const routeUrl = this.$router.resolve({
        name: 'ContractInfo',
        params: { contractNum: row.contractNum },
        query: {
          id: row.contractId,
          masterProjectName: row.projectName,
          distributeFlag: row.distributeFlag
        }
      });
      window.open(routeUrl.href, '_blank');
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchTime.createEndTime = '';
      this.searchTime.createBeginTime = '';
      this.searchTime.postBeginTime = '';
      this.searchTime.postEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },
    exportData () {
      if (!this.searchTime.createBeginTime || !this.searchTime.createEndTime) {
        this.$message.error('请输入合同时间');
        return;
      }
      // this.exportUrl = `${API.defaults.baseURL}/export/exportFinancialSpecialProductInfo?createBeginTime=${this.searchTime.createBeginTime}&createEndTime=${this.searchTime.createEndTime}`;
      // this.$nextTick(() => {
      //   this.$refs.downTag.click();
      // });
      exportFinancialSpecialProductInfo(this.searchTime.createBeginTime, this.searchTime.createEndTime).then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '云桌面合同' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.contractId, row);
    },
    openSalesmanChange (row) {
      this.salesmanChangeRow = row;
      this.salesmanChangeVisible = true;
    },
    searchSalesman (query) {
      window.clearTimeout(this.salesmanSearchTimer);
      if (!query || !query.trim()) {
        this.salesmanOptions = [];
        return;
      }
      this.salesmanSearchTimer = window.setTimeout(() => {
        this.salesmanSearchLoading = true;
        getUserByName(query.trim()).then((res) => {
          const json = res.data;
          if (json.status === '200') {
            this.salesmanOptions = json.data || [];
          }
        }).finally(() => {
          this.salesmanSearchLoading = false;
        });
      }, 200);
    },
    submitSalesmanChange () {
      if (!this.selectedSalesman.userID) {
        this.$message.error('请选择变更后人员');
        return;
      }
      this.salesmanChangeLoading = true;
      changeContractSalesman({
        contractId: this.salesmanChangeRow.contractId,
        salesManCode: this.selectedSalesman.userID
      }).then((res) => {
        if (res.data.status === '200') {
          this.$message.success('销售人员变更成功');
          this.salesmanChangeVisible = false;
          this.doSearch();
        }
      }).finally(() => {
        this.salesmanChangeLoading = false;
      });
    },
    resetSalesmanChange () {
      window.clearTimeout(this.salesmanSearchTimer);
      this.salesmanChangeRow = {};
      this.selectedSalesman = {};
      this.salesmanOptions = [];
      this.salesmanSearchLoading = false;
    },
    applyChange (row) {
      if (String(row.contractNum).startsWith('15')) {
        this.$message.warning('请联系锐捷商务线下开发货单');
        return;
      }
      this.changeReasonRow = row;
      this.contractNum = this.changeReasonRow.contractNum;
      // 每次打开弹窗重置选中值，避免遗留上一次的原因
      this.radio = this.$store.state.user.asSale ? '5' : '1';
      this.changeReasonVisible = true;
    },

    submitChange () {
      if (!this.radio.length) return this.$message.error('请选择一项原因');
      // 017：销售借用纯服务退货由商务在 CES 本地办理，不经过 ECP 订单环节和 SSO 跳转
      if (this.radio === '10') {
        this.applySalesBorrowServiceReturn(this.changeReasonRow);
        return;
      }
      getContractNumByOldNum({
        oldNum: this.contractNum
      }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          let Base64 = require('js-base64').Base64;
          let loginType = localStorage.getItem('loginType');
          let orderUrl = `/returnExchange/edit?orderType=${this.radio}&systemSource=${data.systemSource}&serialNum=${data.serialNum}&customerPoNum=${data.customerPoNum}&serialNumXn=${data.serialNumXn}`;
          let url = Base64.encode(orderUrl);
          let returnExchangePath = '';
          let sidUrl = `https://sid.ruijie.com.cn/`;
          if (loginType) {
            if (window._env_.NODE_ENV === 'pro') {
              returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://rjop.ruijie.com.cn/login?route=${url}&loginType=${loginType}`)}`;
            } else if (window._env_.NODE_ENV === 'test') {
              returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://order-platform-test.ruijie.com.cn/login?route=${url}&loginType=${loginType}`)}`;
            } else if (window._env_.NODE_ENV === 'uat') {
              returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://order-platform-uat.ruijie.com.cn/login?loginType=${loginType}&route=${url}`)}`;
            } else {
              returnExchangePath = `http://order-platform-uat.ruijie.com.cn${orderUrl}`;
            }
          } else {
            if (window._env_.NODE_ENV === 'pro') {
              returnExchangePath = `${sidUrl}login?service=http://rjop.ruijie.com.cn/login?route=${url}`;
            } else if (window._env_.NODE_ENV === 'test') {
              returnExchangePath = `${sidUrl}login?service=http://order-platform-test.ruijie.com.cn/login?route=${url}`;
            } else if (window._env_.NODE_ENV === 'uat') {
              returnExchangePath = `${sidUrl}login?service=http://order-platform-uat.ruijie.com.cn/login?route=${url}`;
            } else {
              returnExchangePath = `http://order-platform-uat.ruijie.com.cn${orderUrl}`;
            }
          }
          window.location.href = returnExchangePath;
        }
      });
    },
    // 生成价外费用
    createNewExtraPriceContract (row, val) {
      this.tableLoading = true;
      if (val === 1) {
        createNewExtraPriceContract(row.contractNum).then((res) => {
          this.tableLoading = false;
          let json = res.data;
          if (json.status === '200') {
            this.$router.push({
              name: 'handleContractquery',
              params: {
                contractNum: json.data
              }
            });
          }
        }).catch(() => {
          this.tableLoading = false;
        });
      } else if (val === 2) {
        this.$router.push({
          name: 'handleContractquery',
          params: {
            contractNum: row.contractNum
          }
        });
      }
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange () {
      this.doSearch();
    },
    // 查看合同附件弹出框
    showAttachment (val) {
      this.contractNum = val;
      this.contractVisible = true;
    },
    doSearch () {
      this.tableLoading = true;

      // 合同时间
      this.searchForm.createBeginTime = this.searchTime.createBeginTime;
      this.searchForm.createEndTime = this.searchTime.createEndTime;

      // 抛单时间
      this.searchForm.postBeginTime = this.searchTime.postBeginTime;
      this.searchForm.postEndTime = this.searchTime.postEndTime;

      selectContractForAssistant({
        ...this.searchForm,
        asSale: this.$store.state.user.asSale,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    // 过单状态
    passingStatus (id, title) {
      let parmasId = id;
      selectById({ id: parmasId }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$alert(json.data.reason, title, {
            confirmButtonText: '确定'
          });
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 召回
    recall (row) {
      this.$confirm('是否确认召回?', '提示', {
        confirmButtonText: '召回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let parmasId = row.contractId;
        recallNewExtraPriceContract({ contractId: parmasId }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('召回成功');
            this.doSearch();
          }
        }).catch((err) => {
          console.log(err);
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 废弃
    discard (row) {
      this.$confirm('是否确认废弃?', '提示', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let parmasId = row.contractId;
        deleteNewExtraPriceContract({ contractId: parmasId }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('废弃成功');
            this.doSearch();
          }
        }).catch((err) => {
          console.log(err);
        });
      }).catch((err) => {
        console.log(err);
      });
      // let parmasId = row.contractId;
      // deleteNewExtraPriceContract({ contractId: parmasId }).then((res) => {
      //   let json = res.data;
      //   if (json.status === '200') {

      //   }
      // }).catch(() => {});
    },
    // 提前开票
    openTicketAgain (row) {
      const routeUrl = this.$router.resolve({
        name: 'ContractInfo',
        params: { contractNum: row.contractNum },
        query: {
          id: row.contractId,
          masterProjectName: row.projectName,
          transact: '9'
        }
      });
      window.open(routeUrl.href, '_blank');
    },

    // 申请发货
    openDeliverGoods (row) {
      const routeUrl = this.$router.resolve({
        name: 'ContractInfo',
        params: { contractNum: row.contractNum },
        query: {
          id: row.contractId,
          masterProjectName: row.projectName,
          transact: '8',
          distributeContractTypeFlag: row.distributeContractTypeFlag
        }
      });
      window.open(routeUrl.href, '_blank');
    },

    // 下载
    downStarting (row) {
      if (this.isDown) return;
      this.isDown = true;
      printInitiationLetterPdf({
        contractId: row.contractId
      }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          downloadUrlFile(data);
          this.isDown = false;
        }
      });
    },
    // 签章
    signature (row) {
      if (this.isSignature) return;
      this.isSignature = true;
      initiationLetterElectronicSignature({
        contractId: row.contractId
      }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          this.$refs.doEsign.openWindow(data);
          this.isSignature = false;
        }
      });
    },
    CompleteEsign (val) {
      if (val.isComplete) {
        this.doSearch();
      }
    },
    showEsing (row) {
      return (row.sources === 'NEW-ECP' && row.contractType === '服务订单' && row.contractStatus === 2);
    }
  }
};
</script>

<style scoped>
/* 退换货原因选项：两列等宽（每项固定 50%）并两两成行，
   让左右两列的圆点与文字严格对齐，避免名称长短不一（如
   “销售借用纯服务退货”比“税率变更”长）把第二列挤得参差不齐。

   ⚠️ 本组件是 scoped 样式：.el-radio-group / .el-radio 由 Element UI 子组件渲染，
   不带本组件的 data-v 属性，必须用 ::v-deep 穿透，否则规则不生效（选项仍参差）。
   与本目录 ../return-replacement-contract/applyDialog.vue 的视觉效果保持一致。 */
::v-deep .cause-list-style > .el-radio-group {
  display: flex;
  flex-wrap: wrap;
}

::v-deep .cause-list-style > .el-radio-group .el-radio {
  box-sizing: border-box;
  flex: 0 0 50%;
  display: flex;
  align-items: center;
  min-width: 0;
  margin: 0 0 8px;
  padding-right: 8px;
  line-height: 22px;
}

::v-deep .cause-list-style > .el-radio-group .el-radio__label {
  padding-left: 8px;
  white-space: normal;
  overflow-wrap: break-word;
}

.mb-10{
  margin-bottom: 10px;
}
.salesman-option-dept {
  float: right;
  color: #8492a6;
  font-size: 12px;
  margin-left: 16px;
}
</style>
